import moment from 'moment';
import { VOFilters, VOFilterType, VOFilterDisplayKeys } from './types';

export const DEFAULT_VO_CREATE_DATE_RANGE: VOFilters[VOFilterType.CREATE_DATE_RANGE] = {
  from: moment().subtract(90, 'days').startOf('day'),
  to: moment().endOf('day'),
};

export const initialVOFiltersValue: VOFilters = {
  [VOFilterType.CREATE_DATE_RANGE]: DEFAULT_VO_CREATE_DATE_RANGE,
  [VOFilterType.CLOSED_DEALS]: {
    isIncludeClosedDeals: false,
  },
  [VOFilterType.DISPLAY]: {
    [VOFilterDisplayKeys.Active]: true,
    [VOFilterDisplayKeys.Testing]: false,
    [VOFilterDisplayKeys.Duplicate]: false,
    [VOFilterDisplayKeys.Other]: false,
  },
  [VOFilterType.TIERS]: {},
  [VOFilterType.STAGE]: {},
  [VOFilterType.STATUS]: [],
  [VOFilterType.LOCATION]: [],
  [VOFilterType.SALES_REP]: [],
  [VOFilterType.SET_OF_DATA]: [],
  [VOFilterType.APPLYING_FOR]: [],
  [VOFilterType.PAYMENT_TYPE]: {},
  [VOFilterType.SALES_MANAGER]: [],
  [VOFilterType.FINANCE_MANAGER]: [],
  [VOFilterType.CREDIT_MANAGER]: [],
  [VOFilterType.OPPORTUNITY_TYPE]: [],
  [VOFilterType.BPF]: {
    stages: [],
    departments: [],
  },
};
